<template>
  <div style="margin-top: 84px">
    <Introduction v-if="isMounted"  />
    <Article v-if="isMounted"
             :article="GlassReplacementIntro" />
    <ServicesIntro v-if="isMounted" />
    <ContactForm v-if="isMounted" />
    <!-- <ComingSoon v-if="isMounted" /> -->
  </div>
</template>

<script lang="ts" setup>
import { GlassReplacementIntro } from '~/constants/articles';
const isMounted = ref(false);
onMounted(() => {
  isMounted.value = true;

});
</script>

<style scoped></style>
<!-- 
style="margin-top: 84px"
       class="ga-6" -->